import script from "./Key.vue?vue&type=script&setup=true&lang=ts"
export * from "./Key.vue?vue&type=script&setup=true&lang=ts"

import "./Key.vue?vue&type=style&index=0&id=a63a47ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63a47ee"]])

export default __exports__